var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H14C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20Z",
    fill: "#7F8594"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.4477 2 11 2.44772 11 3V4C11 4.02775 11.0011 4.05523 11.0033 4.08241C8.16401 4.55712 6.00004 7.02585 6.00004 10V11.9574C6.00004 12.3881 5.84413 12.8042 5.56112 13.1289L4.91668 13.8682C2.82986 16.2623 4.53019 20 7.70609 20H16.294C19.4699 20 21.1702 16.2623 19.0834 13.8682L18.439 13.1289C18.156 12.8042 18 12.3881 18 11.9574V10C18 7.02582 15.836 4.55707 12.9967 4.08239C12.9989 4.05522 13 4.02774 13 4V3C13 2.44772 12.5523 2 12 2ZM8.00004 10C8.00004 7.79086 9.7909 6 12 6C14.2092 6 16 7.79086 16 10V11.9574C16 12.8712 16.3308 13.7542 16.9313 14.443L17.5758 15.1824C18.5347 16.2825 17.7534 18 16.294 18H7.70609C6.24672 18 5.4654 16.2825 6.42432 15.1824L7.06876 14.443C7.66924 13.7542 8.00004 12.8712 8.00004 11.9574V10Z",
    fill: "#7F8594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.a16bd1ddc2ebdf9b7be8df74ab53b6c0.svg";
export { ForwardRef as ReactComponent };